module.exports = __webpack_public_path__ + "img/恢复3.c901cff9.svg";